import type {
  ProductPricing,
  ProductPricingAction,
} from 'src/app/v1/state/types/productPricing';

const defaultState: ProductPricing[] = [
  {
    position: undefined,
    id: undefined,
    price: undefined,
    currency: undefined,
    type: undefined,
    priceHidden: undefined,
  },
];

const RESET = 'tealium/productPricing/RESET';
const UPDATE = 'tealium/productPricing/UPDATE';

export const actionResetProductPricing = () => ({
  type: RESET,
});

export const actionUpdateProductPricing = (value?: ProductPricing[]) => ({
  type: UPDATE,
  value,
});

export default (
  state: ProductPricing[] = defaultState,
  action: ProductPricingAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
